import { useLayoutEffect } from "react";

// Hook to ignore specific console.error messages related to ENS on unsupported chains
export function useIgnoreENSUnsupportedError() {
  useLayoutEffect(() => {
    const originalConsoleError = window.console.error;
    window.console.error = function (...args) {
      if (args[0]?.name === "ChainDoesNotSupportContract") return;
      originalConsoleError.apply(window.console, args);
    };
  }, []);
}
